var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":_vm.transition_name,"mode":"out-in"}},[(_vm.url_traffic)?_c('v-row',{staticClass:"d-block",attrs:{"align-content":"center","justify":"center","no-gutters":""}},[_c('v-img',{class:{ kenbruns: _vm.kenbruns },attrs:{"src":_vm.url_traffic,"max-width":"100vw","max-height":"100vh","contain":""},on:{"error":() => {
            _vm.$emit('on-image-error', { url: _vm.url_traffic });
          }}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }